const gimmickCombinationsData = {
    "Abstainer": {
        "easy": ["Obnoxious", "Incorruptible", "Stoic", "Troublesome", "Solitary", "Arrogant"],
        "hard": ["Weak"]
    },
    "Amateur Wrestler": {
        "easy": ["Athletic", "Cocky", "Hardworking", "Intelligent", "Impressive"],
        "hard": ["Anxious", "Distracted", "Extreme", "Humble", "Unstable"]
    },
    "Big Shot": {
        "easy": ["Glamorous", "Charismatic", "Elegant", "Power-hungry", "Confident", "Selfish", "Arrogant"],
        "hard": ["Ordinary", "Solitary", "Humble", "Naive"]
    },
    "Biker": {
        "easy": ["Tough", "Badass", "Intense", "Troublesome", "Aggressive"],
        "hard": ["Glamorous", "Cowardly", "Cultured", "Elegant"]
    },
    "Body-builder": {
        "easy": ["Attractive", "Strong", "Confident", "Perfect", "Impressive"],
        "hard": ["Miserable", "Cowardly", "Humble", "Weak"]
    },
    "Brute": {
        "easy": ["Strong", "Tough", "Troublesome", "Malicious"],
        "hard": ["Cultured", "Stoic", "Cute"]
    },
    "Bully": {
        "easy": ["Frightening", "Dominating", "Troublesome", "Aggressive", "Cowardly", "Miserable", "Weak", "Selfish"],
        "hard": ["Lovable", "Heroic", "Reserved"]
    },
    "Cheerleader": {
        "easy": ["Charismatic", "Cute", "Attractive", "Enthusiastic", "Athletic", "Naive", "Distracted"],
        "hard": ["Frightening", "Malicious", "Humble", "Solitary"]
    },
    "Child": {
        "easy": ["Cute", "Ordinary", "Enthusiastic", "Lovable", "Trusting", "Fearless", "Naive"],
        "hard": ["Attractive", "Badass", "Malicious", "Sleazy", "Extreme"]
    },
    "Cowboy": {
        "easy": ["Tough", "Fun-loving", "Troublesome", "Familial", "Heroic", "Cultured", "Reserved"],
        "hard": ["Glamorous", "Anxious", "Naive", "Trusting", "Intense"]
    },
    "Cult Leader": {
        "easy": ["Frightening", "Bizarre", "Unstable", "Power-hungry", "Charismatic", "Extreme", "Fearless", "Wise"],
        "hard": ["Glamorous", "Fun-loving", "Incorruptible", "Elegant", "Lovable", "Heroic", "Authoritarian"]
    },
    "Occultist": {
        "easy": ["Bizarre", "Passionate", "Stoic", "Tranquilo", "Fearless", "Solitary", "Reserved"],
        "hard": ["Distracted", "Glamorous", "Ordinary", "Fun-loving", "Lovable", "Elegant", "Intense"]
    },
    "Degenerate": {
        "easy": ["Badass", "Fun-loving", "Troublesome", "Sleazy", "Obnoxious"],
        "hard": ["Hardworking", "Cultured", "Humble", "Authoritarian"]
    },
    "Demon": {
        "easy": ["Frightening", "Bizarre", "Fearless", "Intense", "Malicious", "Heroic", "Unstable"],
        "hard": ["Glamorous", "Ordinary", "Incorruptible", "Fun-loving", "Elegant", "Cultured"]
    },
    "Drug Lord": {
        "easy": ["Tranquilo", "Charismatic", "Badass", "Power-hungry", "Deceitful", "Familial", "Wise"],
        "hard": ["Naive", "Trusting", "Weak", "Incorruptible", "Authoritarian"]
    },
    "Druggie": {
        "easy": ["Fun-loving", "Miserable", "Anxious", "Selfish", "Unpredictable", "Distracted"],
        "hard": ["Calculating", "Perfect", "Stoic", "Hardworking", "Elegant"]
    },
    "Enigma": {
        "easy": ["Bizarre", "Intense", "Charismatic", "Unpredictable", "Solitary", "Tranquilo"],
        "hard": ["Cultured", "Power-hungry", "Naive", "Elegant"]
    },
    "Executive": {
        "easy": ["Power-hungry", "Confident", "Calculating", "Cultured", "Authoritarian", "Cowardly", "Selfish"],
        "hard": ["Naive", "Distracted", "Unpredictable", "Heroic", "Bizarre"]
    },
    // Empty
    "Fighter": {
        "easy": [],
        "hard": []
    },
    "Foreigner": {
        "easy": ["Aggressive", "Arrogant", "Cultured", "Strong", "Dominating", "Obnoxious"],
        "hard": ["Hardworking", "Heroic", "Humble", "Lovable"]
    },
    "Game Dev.": {
        "easy": ["Fun-loving", "Hardworking", "Lovable", "Anxious", "Passionate"],
        "hard": ["Distracted", "Unpredictable", "Unstable"]
    },
    "Giant": {
        "easy": ["Strong", "Frightening", "Aggressive", "Dominating", "Lovable"],
        "hard": ["Ordinary", "Cowardly", "Anxious", "Weak"]
    },
    "Jock": {
        "easy": ["Athletic", "Attractive", "Dominating", "Arrogant", "Confident", "Cocky", "Selfish"],
        "hard": ["Wise", "Intelligent", "Badass", "Reserved", "Heroic"]
    },
    "Kickboxer": {
        "easy": ["Athletic", "Tough", "Badass", "Intense", "Calculating"],
        "hard": ["Weak", "Unstable", "Distracted", "Cowardly"]
    },
    "Lunatic": {
        "easy": ["Unstable", "Unpredictable", "Aggressive", "Extreme", "Malicious", "Distracted"],
        "hard": ["Elegant", "Wise", "Reserved", "Trusting"]
    },
    "Martian": {
        "easy": ["Cute", "Bizarre", "Miserable", "Familial", "Extreme"],
        "hard": ["Perfect", "Elegant", "Cowardly", "Power-hungry", "Dominating"]
    },
    "Mobster": {
        "easy": ["Sleazy", "Tough", "Troublesome", "Deceitful", "Familial"],
        "hard": ["Trusting", "Incorruptible", "Naive", "Solitary"]
    },
    "Monster": {
        "easy": ["Frightening", "Aggressive", "Malicious", "Fearless", "Attractive", "Strong"],
        "hard": ["Cultured", "Elegant", "Cowardly", "Cute", "Reserved"]
    },
    "Movie Star": {
        "easy": ["Glamorous", "Attractive", "Cocky", "Obnoxious", "Charismatic"],
        "hard": ["Extreme", "Authoritarian", "Reserved", "Frightening"]
    },
    "Musician": {
        "easy": ["Passionate", "Arrogant", "Cocky", "Bizarre"],
        "hard": ["Strong", "Reserved", "Humble"]
    },
    "Mythical Being": {
        "easy": ["Bizarre", "Frightening", "Malicious", "Heroic", "Impressive"],
        "hard": ["Weak", "Cultured", "Elegant", "Cowardly", "Ordinary"]
    },
    "Opportunist": {
        "easy": ["Cowardly", "Malicious", "Sleazy", "Calculating", "Weak", "Selfish"],
        "hard": ["Naive", "Distracted", "Hardworking", "Incorruptible", "Badass", "Dominating"]
    },
    "Patriot": {
        "easy": ["Passionate", "Hardworking", "Incorruptible", "Lovable", "Heroic", "Fearless", "Authoritarian"],
        "hard": ["Frightening", "Troublesome", "Cowardly", "Selfish", "Weak", "Obnoxious"]
    },
    "Philosophist": {
        "easy": ["Wise", "Intelligent", "Obnoxious", "Cultured", "Stoic", "Authoritarian", "Tranquilo"],
        "hard": ["Naive", "Sleazy", "Fun-loving", "Anxious"]
    },
    "Pirate": {
        "easy": ["Lovable", "Badass", "Fun-loving", "Troublesome", "Deceitful"],
        "hard": ["Naive", "Trusting", "Cultured", "Cowardly", "Anxious"]
    },
    "Police Officer": {
        "easy": ["Tough", "Aggressive", "Fearless", "Incorruptible", "Authoritarian"],
        "hard": ["Anxious", "Cowardly", "Naive", "Unpredictable", "Weak"]
    },
    "Prize Fighter": {
        "easy": ["Tough", "Malicious", "Familial", "Calculating", "Selfish"],
        "hard": ["Distracted", "Incorruptible", "Cute", "Anxious", "Cowardly"]
    },
    "Punk": {
        "easy": ["Badass", "Troublesome", "Arrogant", "Obnoxious", "Selfish"],
        "hard": ["Cultured", "Stoic", "Authoritarian"]
    },
    "Rapper": {
        "easy": ["Obnoxious", "Flamboyant", "Badass", "Passionate", "Intense"],
        "hard": ["Reserved", "Solitary"]
    },
    "Rich Person": {
        "easy": ["Obnoxious", "Flamboyant", "Attractive", "Power-hungry", "Cultured", "Impressive", "Selfish",
                 "Perfect"],
        "hard": ["Incorruptible", "Extreme", "Anxious", "Bizarre"]
    },
    "Rising Star": {
        "easy": ["Flamboyant", "Athletic", "Impressive", "Confident", "Cocky", "Hardworking", "Perfect"],
        "hard": ["Humble", "Wise", "Ordinary", "Cowardly", "Fun-loving", "Miserable", "Reserved"]
    },
    "Rockstar": {
        "easy": ["Intense", "Obnoxious", "Cocky", "Flamboyant", "Charismatic"],
        "hard": ["Reserved", "Humble", "Ordinary", "Cultured"]
    },
    "Royalty": {
        "easy": ["Power-hungry", "Reserved", "Impressive", "Elegant", "Authoritarian"],
        "hard": ["Ordinary", "Solitary", "Naive", "Extreme", "Intense"]
    },
    "Shoot Fighter": {
        "easy": ["Tough", "Strong", "Badass", "Aggressive", "Fearless", "Intense"],
        "hard": ["Cowardly", "Anxious", "Reserved", "Distracted", "Weak"]
    },
    "Sidekick": {
        "easy": ["Ordinary", "Passionate", "Cute", "Trusting", "Naive", "Heroic", "Humble", "Distracted", "Weak"],
        "hard": ["Cowardly", "Strong", "Obnoxious", "Cocky", "Selfish"]
    },
    "Singer": {
        "easy": ["Glamorous", "Attractive", "Enthusiastic", "Charismatic"],
        "hard": ["Aggressive", "Frightening", "Unstable"]
    },
    "Sports Star": {
        "easy": ["Athletic", "Strong", "Cocky", "Impressive", "Confident"],
        "hard": ["Ordinary", "Cowardly", "Reserved", "Authoritarian", "Weak", "Humble"]
    },
    "Spot Monkey": {
        "easy": ["Athletic", "Flamboyant", "Enthusiastic", "Cocky", "Fearless", "Extreme"],
        "hard": ["Anxious", "Cowardly", "Humble", "Weak"]
    },
    "Superhero": {
        "easy": ["Strong", "Tough", "Intelligent", "Fearless", "Incorruptible", "Heroic", "Humble", "Reserved",
                 "Perfect"],
        "hard": ["Cowardly", "Obnoxious", "Cocky", "Selfish", "Authoritarian", "Naive", "Weak"]
    },
    // Empty
    "Superstar": {
        "easy": [],
        "hard": []
    },
    "Thug": {
        "easy": ["Badass", "Troublesome", "Aggressive", "Malicious", "Tough"],
        "hard": ["Reserved", "Cowardly", "Perfect", "Fun-loving", "Incorruptible"]
    },
    "Undead": {
        "easy": ["Frightening", "Bizarre", "Fearless", "Malicious", "Intense", "Solitary"],
        "hard": ["Cute", "Glamorous", "Attractive", "Fun-loving", "Cowardly", "Weak"]
    },
    "Underdog": {
        "easy": ["Fearless", "Ordinary", "Passionate", "Hardworking", "Lovable", "Humble", "Heroic"],
        "hard": ["Cowardly", "Strong", "Obnoxious", "Power-hungry", "Cocky", "Weak", "Selfish", "Perfect"]
    },
    "Vampire": {
        "easy": ["Frightening", "Attractive", "Intense", "Malicious"],
        "hard": ["Authoritarian", "Ordinary", "Fun-loving", "Weak", "Cowardly"]
    },
    "Veteran": {
        "easy": ["Humble", "Wise", "Badass", "Lovable", "Miserable", "Hardworking"],
        "hard": ["Naive", "Anxious", "Ordinary", "Cowardly"]
    },
    "VIP": {
        "easy": ["Glamorous", "Cocky", "Confident", "Obnoxious", "Sleazy", "Selfish"],
        "hard": ["Ordinary", "Solitary", "Humble", "Naive", "Heroic"]
    },
    "Voodoo": {
        "easy": ["Frightening", "Intense", "Malicious", "Bizarre", "Unpredictable"],
        "hard": ["Elegant", "Cute", "Ordinary"]
    },
    // Empty
    "Wrestler": {
        "easy": [],
        "hard": []
    }
};

export {gimmickCombinationsData}
